var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "home-slider",
      class: [
        { "home-slider--changing-slides": _vm.isChangingSlides },
        _vm.sliderId
      ]
    },
    [
      _c(
        "div",
        { staticClass: "slider-wrapper home-slider__slider" },
        [
          _vm.sliderData.length
            ? _c(
                "swiper",
                {
                  ref: "slider",
                  attrs: { options: _vm.swiperOptions },
                  on: {
                    "slide-change-transition-start":
                      _vm.onSwiperSlideChangeTransitionStart,
                    "slide-change-transition-end":
                      _vm.onSwiperSlideChangeTransitionEnd
                  }
                },
                [
                  _vm._l(_vm.sliderData, function(slide, index) {
                    return _c("swiper-slide", { key: index }, [
                      _c("div", { staticClass: "home-slider__slide" }, [
                        _c("div", { staticClass: "home-slider__slide__body" }, [
                          _c("div", {
                            staticClass:
                              "home-slider__slide__body__description",
                            domProps: { innerHTML: _vm._s(slide.description) }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "home-slider__slide__body__footer" },
                            [
                              _c(
                                "a",
                                {
                                  staticClass: "read-more-link",
                                  attrs: { href: slide.page_link }
                                },
                                [
                                  _c("span", [_vm._v("Learn More")]),
                                  _vm._v(" "),
                                  _c(
                                    "svg",
                                    {
                                      attrs: {
                                        width: "496px",
                                        height: "496px",
                                        viewBox: "0 0 496 496",
                                        version: "1.1",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        "xmlns:xlink":
                                          "http://www.w3.org/1999/xlink"
                                      }
                                    },
                                    [
                                      _c(
                                        "g",
                                        {
                                          attrs: {
                                            id: "Page-1",
                                            stroke: "none",
                                            "stroke-width": "1",
                                            fill: "none",
                                            "fill-rule": "evenodd"
                                          }
                                        },
                                        [
                                          _c("path", {
                                            attrs: {
                                              d:
                                                "M248,0 C385,0 496,111 496,248 C496,385 385,496 248,496 C111,496 0,385 0,248 C0,111 111,0 248,0 Z M361.9,231 L226.4,95.5 C217,86.1 201.8,86.1 192.5,95.5 L175.5,112.5 C166.1,121.9 166.1,137.1 175.5,146.4 L277.1,248 L175.5,349.6 C166.1,359 166.1,374.2 175.5,383.5 L192.5,400.5 C201.9,409.9 217.1,409.9 226.4,400.5 L361.9,265 C371.3,255.6 371.3,240.4 361.9,231 Z",
                                              id: "icon-cheron-right-circled",
                                              fill: "#000000",
                                              "fill-rule": "nonzero"
                                            }
                                          })
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "home-slider__slide__image" },
                          [
                            _c("div", {
                              key: index,
                              staticClass: "image",
                              style: {
                                backgroundImage:
                                  "url(" + slide.image.sizes.large + ")"
                              }
                            })
                          ]
                        )
                      ])
                    ])
                  }),
                  _vm._v(" "),
                  _vm.showNavigation
                    ? _c("div", {
                        staticClass: "swiper-button-prev",
                        attrs: { slot: "button-prev" },
                        slot: "button-prev"
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showNavigation
                    ? _c("div", {
                        staticClass: "swiper-button-next",
                        attrs: { slot: "button-next" },
                        slot: "button-next"
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showPagination
                    ? _c("div", {
                        staticClass: "swiper-pagination",
                        attrs: { slot: "pagination" },
                        slot: "pagination"
                      })
                    : _vm._e()
                ],
                2
              )
            : _vm._e()
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /home/omer/Projects/Arcadian/embl/wp-content/themes/embl/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/home/omer/Projects/Arcadian/embl/wp-content/themes/embl/node_modules/vue-loader/lib?{}!./scripts/vue/HomeSlider.vue?vue&type=template&id=00f3f054&
// module id = 119
// module chunks = 0